import { LoadingScreen } from '@tyro/core/lazy-loader';
import { lazyWithRetry } from '@tyro/core/utils';
import type { RouteObject } from '@tyro/router/types';
import { Suspense } from 'react';

const VerifyProfile = lazyWithRetry(() => import('./pages/verify-profile'));

function Loadable({ children }: { children: React.ReactNode }) {
  return <Suspense fallback={<LoadingScreen />}>{children}</Suspense>;
}

export const routes: RouteObject[] = [
  {
    path: '/verify',
    element: (
      <Loadable>
        <VerifyProfile />
      </Loadable>
    ),
  },
];
